import { Dialog } from "@headlessui/react";
import DialogBackdrop from "./DialogBackdrop";
import { Trans, useTranslation } from "react-i18next";

export const UnlockUserConfirmationModel = ({
  isUnlockUserConfirmation,
  setIsUnlockUserConfirmation,
}) => {
  const { t } = useTranslation();

  return (
    <>
      <Dialog
        open={isUnlockUserConfirmation}
        onClose={() => setIsUnlockUserConfirmation(false)}
        className="ui-dialogs"
      >
        {/* The backdrop, rendered as a fixed sibling to the panel container */}
        <DialogBackdrop />
        {/* Full-screen container to center the panel */}
        <div className="fixed inset-0 flex items-center justify-center p-4">
          <Dialog.Panel
            role="dialog"
            aria-modal="true"
            className="ui-default-dialog"
          >
            <Dialog.Title className="font-body text-xl font-bold text-left">
              {t("UnlockUserConfirmationModel-dialogTitle")}
            </Dialog.Title>
            <button
              className="ui-default-dialog-close"
              aria-label={t("UnlockUserConfirmationModel-ariaLabel")}
              onClick={() => setIsUnlockUserConfirmation(false)}
            >
              <svg
                className="ui-icon h-3.5 w-3.5"
                focusable="false"
                aria-hidden="true"
                role="presentation"
              >
                <use href="#ui-icon-close"></use>
              </svg>
            </button>
            <hr />
            <Dialog.Description>
              {t("UnlockUserConfirmationModel-dialogDescription")}
            </Dialog.Description>

            <div className="block text-right mt-6">
              <button
                className="ui-btn-secondary ui-btn-min-w mt-4"
                onClick={() => setIsUnlockUserConfirmation(false)}
              >
                <Trans
                  i18nKey="UnlockUserConfirmationModel-closeUserConfirmationButton"
                  components={{ span: <span className="sr-only" /> }}
                />
              </button>
            </div>
          </Dialog.Panel>
        </div>
      </Dialog>
    </>
  );
};
